

<template>
    {{ priceFormat(Price) }}
</template>

<script setup>

const props = defineProps({
    Price: {
    type: String,
    required: true,
  }
});

const priceFormat = ((price) => {
      if(price == null || price == ""){
        return "000"
      }
      price = parseInt(price)
      return price.toLocaleString()
    })


</script>
